import { TSetPurposeUS } from 'common/types'
import { makeBridgeRequest } from 'common/helpers'

import { updatePreferencesUs } from './us-api'

export const setPurposesUS = ({
  body,
  productId,
  userAccountType,
  userCountry,
  userSelectedEntity,
  headers,
  isUSBranch,
}: TSetPurposeUS) =>
  makeBridgeRequest(
    updatePreferencesUs({
      body,
      userCountry,
      productId,
      userAccountType,
      userSelectedEntity,
      headers,
      isUSBranch,
    }),
    undefined,
    false,
    isUSBranch,
  ).then((response) => response)
